import type { API } from 'chessboard/plugins/highlights/config/types';
import type { Core } from 'chessboard/core/config/types';
import type { UpdateParameters } from 'chessboard/plugins/highlights/api';

/**
 * add highlights when initializing plugin
 */
export function init(context: Core.Context) {
  const { api, renderer } = context;
  if (!api.markings || !api.highlights) {
    return;
  }

  const highlightsApi = <API<UpdateParameters>>api.highlights;

  // clear the internal highlight state to ensure all highlights are added
  highlightsApi.clearState();

  // TODO: https://chesscom.atlassian.net/browse/CV-299724
  // Updating highlights must be done by calling this handler that requires an event it never uses.
  // Refactor of the highlights module system would make this cleaner to call here.
  const { toAdd } = highlightsApi.update(
    { data: {}, type: 'DummyHighlightInitEventName' },
    context,
  );

  renderer?.addHighlights(toAdd, context);
}
